export const DateFormatsConst = {
    FULL_DATE_FULL_YEAR: 'M/d/y',
    ISO_FULL_DATE_FULL_YEAR: 'y-M-dd',
    MONTH_DAY: 'M/d',
    MONTH_YEAR: 'MMM, yy',
    COMMON_DATEFORMAT: 'Pp', // 04/29/1453, 12:00 AM
    FULL_DATE_WITH_TIME: 'M/d/y, h:mm:ss a',
    TIME_WITH_FULL_DATE: 'h:mma M/d/y',
};

export const ISO8601RegExp: RegExp =
    /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;

export const WithoutTISO8601RegExp: RegExp =
    /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9]) (2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;
